var exports = {
  "Qs": "CameraPreviewModal.module__content___UlkzdU",
  "Wc": "CameraPreviewModal.module__backgroundSection___UlkzdU",
  "Pz": "CameraPreviewModal.module__backgroundLabel___UlkzdU",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___UlkzdU",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___UlkzdU",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___UlkzdU",
  "j": "CameraPreviewModal.module__videoContainer___UlkzdU",
  "qr": "CameraPreviewModal.module__footer___UlkzdU",
  "wu": "CameraPreviewModal.module__footerStart___UlkzdU",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___UlkzdU",
  "Ki": "CameraPreviewModal.module__video___UlkzdU",
  "CT": "CameraPreviewModal.module__mirroredVideo___UlkzdU",
  "Lw": "CameraPreviewModal.module__overlay___UlkzdU",
  "um": "CameraPreviewModal.module__overlayText___UlkzdU",
  "nU": "CameraPreviewModal.module__overlayTextMedium___UlkzdU",
  "$q": "CameraPreviewModal.module__errorOverlay___UlkzdU",
  "kc": "CameraPreviewModal.module__errorText___UlkzdU",
  "JU": "CameraPreviewModal.module__errorTitle___UlkzdU",
  "m2": "CameraPreviewModal.module__errorDetail___UlkzdU",
};

module.exports = exports;
